<ion-card *ngIf="!readOnly">
  <ion-card-header>
    <ion-item lines="none">
      <b>{{ client.firstName }} {{ client.lastName }}</b>
    </ion-item>
  </ion-card-header>
  <ion-card-content>
    <ion-list class="ion-margin-bottom">
      <ion-item
        button="true"
        (click)="lineitemClickHandler(lineitem)"
        *ngFor="let lineitem of clientLineitems"
        [ngClass]="{ 'sm-error': lineitem.isItemRefund() }"
        lines="none"
        [disabled]="sale && sale.isRefundSale()"
      >
        <span
          >{{ lineitem.quantity }} x {{ lineitem.name }} by
          {{ lineitem.stylist.firstName }}
          {{ lineitem.stylist.lastName.charAt(0) }}</span
        >
        <br />
        <div slot="end">
          <span [ngClass]="{ 'sm-error': lineitem.isItemRefund() }">
            {{ lineitem.price * lineitem.quantity | salonMonsterCurrency }}
          </span>

          <ng-container *ngIf="lineitem.discount">
            &nbsp; - &nbsp;
            <span
              [ngClass]="{ 'sm-error': lineitem.isItemRefund() }"
              *ngIf="lineitem.discount"
            >
              {{ lineitem.discount ? (lineitem.discount | discountLabel) : "" }}
            </span>
            &nbsp; = &nbsp;
            <span [ngClass]="{ 'sm-error': lineitem.isItemRefund() }">{{
              lineitem.preTaxTotals | salonMonsterCurrency
            }}</span>
          </ng-container>
        </div>
      </ion-item>
    </ion-list>

    <div
      *ngIf="clientLineitems.count() == 0"
      margin-left
      class="ion-margin-bottom"
    >
      <ion-note> No items have been added yet. </ion-note>
      <br /><br />
    </div>
    <div class="ion-padding-top" *ngIf="!sale.isRefundSale()">
      <ion-button
        (click)="addServiceClickHandler()"
        size="small" 
        class="tertiary-button ion-margin-end"
        >+ Service
      </ion-button>
      <ion-button 
        (click)="addProductClickHandler()" 
        size="small" 
        class="tertiary-button ion-margin-end"
        >+ Product
      </ion-button>
      <!-- <ion-button 
        (click)="addProductClickHandler()" 
        size="small" 
        class="tertiary-button"
        >+ <ion-icon name="gift"></ion-icon>
      </ion-button>       -->
    </div>
  </ion-card-content>
</ion-card>

<ion-list *ngIf="readOnly">
  <ion-list>
    <ion-item-group>
      <ion-item-divider color="light"
        >{{ client.firstName }} {{ client.lastName }}</ion-item-divider
      >
      <ion-item
        *ngFor="let lineitem of clientLineitems"
        [ngClass]="{ 'sm-error': lineitem.isItemRefund() }"
        (click)="lineitemClickHandler(lineitem)"
      >
        {{ lineitem.quantity }} x {{ lineitem.name }} by
        {{ lineitem.stylist.firstName }}
        {{ lineitem.stylist.lastName.charAt(0) }}
        <span slot="end" [ngClass]="{ 'sm-error': lineitem.isItemRefund() }">{{
          lineitem.preTaxTotals | salonMonsterCurrency
        }}</span>
      </ion-item>
    </ion-item-group>

    <ion-item *ngIf="clientLineitems.count() == 0">
      <ion-note> No items have been added yet. </ion-note>
      <br /><br />
    </ion-item>
  </ion-list>
</ion-list>
